import { API_URL, OFFERS_API_URL } from './constants'
import { OFFERS_PREVIEW_BUILD } from './offer-env'
// Preview-only routing switch, honoured only by a build that says it is a
// preview or local development (see OFFERS_API_URL in constants.tsx).
export const USE_V2_OFFERS_PREVIEW =
	process.env.NEXT_PUBLIC_OFFERS_V2_PREVIEW === '1' && OFFERS_PREVIEW_BUILD
const natIds = new Set<string>()
export function rememberNatOffer(id: string) {
	natIds.add(id)
	try {
		localStorage.setItem(`ow:nat-offer-api:${id}`, '1')
	} catch {}
}
export function offerApi(path: string, body?: unknown) {
	const id = path.match(/^\/market\/offers\/([^/]+)\//)?.[1]
	let nat =
		(USE_V2_OFFERS_PREVIEW && path === '/market/offers/build') ||
		!!(body && typeof body === 'object' && 'nat_terms' in body && body.nat_terms)
	if (id) {
		nat ||= natIds.has(id)
		try {
			nat ||= localStorage.getItem(`ow:nat-offer-api:${id}`) === '1'
		} catch {}
	}
	return nat ? OFFERS_API_URL : API_URL
}
